// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__27xLM","consentsList":"PatientConsents_consentsList__ebV8K","consentsListEmpty":"PatientConsents_consentsListEmpty__2yTkO"};